module.exports = require("core-js/library/fn/number/min-safe-integer");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/min-safe-integer.js
// module id = 1366
// module chunks = 0